import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { MstarCategoryColors } from './colors/morning-star-category-colors.config';

@NgModule({
	imports: [CommonModule]
})
export class ConfigModule {
	public static forRoot(): ModuleWithProviders<ConfigModule> {
		return {
			ngModule: ConfigModule,
			providers: [MstarCategoryColors]
		};
	}
}
